import LocationHero from "./components/LocationHero";
import TrustBar from "../../components/feature/TrustBar";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/TestimonialsSection";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTASection from "../../components/feature/FinalCTASection";
import { locationFaqs } from "../../mocks/faq";
import { Link } from "react-router-dom";
import { services } from "../../mocks/services";

const locationTrust = [
  { number: "SA", label: "San Antonio Based", icon: "ri-map-pin-line" },
  { number: "50+", label: "Miles Service Radius", icon: "ri-road-map-line" },
  { number: "15+", label: "Years in Texas", icon: "ri-award-line" },
  { number: "5★", label: "Local Reviews", icon: "ri-star-line" },
];

const locationAI = {
  title: "Serving San Antonio & Surrounding Areas",
  subtitle: "Local photography coverage guide",
  what: "Precious Keepsakes Photography is a San Antonio-based luxury portrait studio serving families throughout the greater San Antonio metro area, Texas Hill Country, and beyond. Photographer Stephanie is available for in-studio and on-location sessions across the entire region.",
  services: [
    "San Antonio newborn photography — in-studio and on-location",
    "San Antonio wedding photography — full city coverage",
    "Hill Country portrait sessions — Boerne, New Braunfels, Kerrville",
    "Northeast SA — Schertz, Converse, Universal City",
    "Destination sessions — available throughout Texas",
  ],
  benefits: [
    "San Antonio-based — no out-of-city travel surcharge within metro",
    "Full studio setup brought to your location",
    "Familiar with best scenic spots across the Alamo City",
    "Available for travel throughout Texas Hill Country",
    "Local reputation with 500+ San Antonio families served",
  ],
  process: [
    "Contact us — call 210-815-4698 or use our inquiry form",
    "Discuss location — studio, home, or scenic outdoor spot",
    "Confirm your session date and vision",
    "Stephanie arrives fully equipped — you just show up",
  ],
};

export default function LocationPage() {
  return (
    <main>
      <LocationHero />
      <TrustBar items={locationTrust} />

      {/* Local Services Overview */}
      <section className="bg-pk-ivory py-24">
        <div className="max-w-screen-xl mx-auto px-8">
          <div className="text-center mb-14">
            <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">Available Locally</span>
            <h2 className="font-display text-5xl font-medium text-pk-charcoal mt-4 leading-tight">
              All Sessions Available in San Antonio
            </h2>
            <p className="font-sans text-sm text-pk-muted mt-4 max-w-lg mx-auto leading-7">
              Every Precious Keepsakes service is available locally across San Antonio and the surrounding region.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((s) => (
              <div key={s.id} className="bg-pk-cream rounded-sm overflow-hidden">
                <div className="w-full h-48 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8">
                  <h3 className="font-display text-2xl font-semibold text-pk-charcoal mb-2">{s.title}</h3>
                  <p className="font-sans text-xs text-pk-muted leading-5 mb-4">{s.shortDesc}</p>
                  <div className="flex items-center gap-2 text-pk-gold">
                    <div className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line text-sm" /></div>
                    <span className="font-sans text-xs">Available in San Antonio, TX</span>
                  </div>
                  <Link to="/services" className="mt-4 inline-flex items-center gap-1 font-sans text-xs tracking-widest uppercase text-pk-charcoal hover:text-pk-gold transition-colors cursor-pointer">
                    Learn More <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <AIAnswerBlock {...locationAI} />
      <ProcessSection title="How Local Sessions Work" subtitle="Simple, seamless, and built around your schedule" />
      <WhyChooseUs />
      <ServiceAreasSection />
      <TestimonialsSection title="Loved By San Antonio Families" />
      <FAQSection faqs={locationFaqs} title="Local Coverage Questions" subtitle="Everything you need to know about sessions in your area" />
      <FinalCTASection
        title="Serving San Antonio Families With Heart"
        subtitle="Ready to book your session? Stephanie serves the entire San Antonio metro and Hill Country region."
        ctaLabel="Book a Local Session"
        backgroundImage="https://images-pw.pixieset.com/site/BAJyQr/wdadAo/B1B-328cb125-1500.jpg"
      />
    </main>
  );
}